import { Diagram } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/components/diagrams/Diagram';
import { DiagramArrow } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/components/diagrams/DiagramArrow';
import { DiagramBox } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/components/diagrams/DiagramBox';
import { DiagramText } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/components/diagrams/DiagramText';
import { ArrowTone } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/types/ArrowTone';
import { BoxTone } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/types/BoxTone';
import { TextTone } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/types/TextTone';

export const AutomaticModeDiagram = () => (
  <Diagram viewBox="0 0 340 110">
    <DiagramBox x={10} y={40} width={70} tone={BoxTone.DONE} />
    <DiagramText x={45} y={57}>
      1º A ✗
    </DiagramText>
    <DiagramText x={45} y={82} tone={TextTone.NO} small tId="REJECTED" />
    <DiagramArrow d="M80,53 L128,53" tone={ArrowTone.ACCENT} />
    <DiagramText x={104} y={36} tone={TextTone.ANY} small bold tId="PLATFORM">
      {'⚙ '}
    </DiagramText>
    <DiagramBox x={130} y={40} width={70} tone={BoxTone.ANY} />
    <DiagramText x={165} y={57} bold>
      2º C
    </DiagramText>
    <DiagramText x={165} y={82} tone={TextTone.ANY} small tId="CONSULTING" />
    <DiagramArrow d="M200,53 L248,53" tone={ArrowTone.MUTED} dashed />
    <DiagramText x={224} y={36} tone={TextTone.MUTED} small tId="WHEN_ANSWERS" />
    <DiagramBox x={250} y={40} width={70} tone={BoxTone.GHOST} />
    <DiagramText x={285} y={57} tone={TextTone.GHOST}>
      3º B
    </DiagramText>
    <DiagramText x={285} y={82} tone={TextTone.MUTED} small tId="WAITING" />
    <DiagramText x={170} y={104} tone={TextTone.MUTED} small tId="AUTO_HINT" />
  </Diagram>
);
